/**
 * Ryan O'Dowd
 * 2024-02-26
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  clearReadingHistory,
  removeFromReadingHistory,
} from '@utils/store/actions';
import Button from '@components/common/Button';
import CPassage from '@classes/Passage';
import Dialog from '@components/common/Dialog';
import {
  IconButton,
} from 'react-native-paper';
import ListItem from '@components/ListItem';
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const ReadingHistoryDialog = (props: ReadingHistoryDialogProps) => {
  const dispatch = hooks.useTypedDispatch();
  const i18n = hooks.useI18n();
  const styles = hooks.useStyles(getStyles);

  const preferredTranslation = hooks.usePreferredTranslation();
  const readingHistory = hooks.useTypedSelector((state) => state.readingHistory);

  return (
    <Dialog
      visible={true}
      onDismiss={() => props.onClose()}
    >{/* @TODO: abstract this modal to it's own component and make available in main dashboard component as well */}
      {/* @TODO: this dialog doesn't fit on some screen sizes (definitely not if a11y is set to extra large) */}
      <Dialog.Title>{i18n('readingHistory')}</Dialog.Title>
      <Dialog.Content>
        {readingHistory.map((chapterHistory) => {
          const chapter = CPassage.getChapterById(chapterHistory.chapterId);
          const bookName = CPassage.getBookName(preferredTranslation.id, chapter.book_id);
          return (
            <View
              key={chapterHistory.chapterId}
              style={styles.chapterHistoryRow}
            >
              <IconButton// @TODO: replace with swipe to delete
                style={styles.removeButton}
                icon='close'
                iconColor={styles.colors.text}
                size={18}
                onPress={() => dispatch(removeFromReadingHistory(chapterHistory.chapterId))}
              />
              <ListItem
                containerStyles={styles.chapterHistoryListItem}
                onPress={() => props.onSelect(chapterHistory.chapterId)}
              >
                <Text style={styles.chapterHistoryText}>{`${bookName} ${chapter.chapter_number}`}</Text>
              </ListItem>
            </View>
          );
        })}
      </Dialog.Content>
      <Dialog.Actions>
        <Button
          mode='text'
          theme={styles.colors.alert}
          onPress={() => dispatch(clearReadingHistory())}// @TODO: ask for confirmation
        >
          {i18n('clearHistory')}
        </Button>
        <Button
          mode='contained'
          onPress={() => props.onClose()}
        >
          {i18n('close')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

class ReadingHistoryDialogProps {
  onClose: () => void;
  onSelect: (chapterId: number) => void;
};

export default ReadingHistoryDialog;
